import React from 'react';
import { Center, Container } from '@fiverr-private/layout_components';

interface Props {
  children: React.ReactNode;
}

export const OnboardingRoutingWrapper = ({ children }: Props) => (
  <Center height="100%">
    <Container maxWidth="680px" width="100%" height="100%" paddingTop="12">
      {children}
    </Container>
  </Center>
);
